module.exports = __webpack_public_path__ + "static/media/room_and_board.3fca195c.png";